// src/lib/pdfLogo.js
// Prépare un logo (PNG, JPEG, WebP, SVG ou data URL) pour jsPDF : conversion en PNG
// et dimensions qui tiennent dans une boîte maxW × maxH (mm) en gardant les proportions.
// jsPDF ne décode ni le WebP ni le SVG, et déformait le logo dans un cadre fixe de 30 × 15 mm.

export async function loadLogoForPdf(url, { maxW = 30, maxH = 15 } = {}) {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Logo introuvable (${response.status})`);
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);

  try {
    const img = await new Promise((resolve, reject) => {
      const i = new Image();
      i.onload = () => resolve(i);
      i.onerror = () => reject(new Error("Logo illisible"));
      i.src = objectUrl;
    });

    const pxW = img.naturalWidth || img.width;
    const pxH = img.naturalHeight || img.height;
    if (!pxW || !pxH) throw new Error("Logo sans dimensions");

    const canvas = document.createElement("canvas");
    canvas.width = pxW;
    canvas.height = pxH;
    canvas.getContext("2d").drawImage(img, 0, 0, pxW, pxH);

    const scale = Math.min(maxW / pxW, maxH / pxH);
    return { dataUrl: canvas.toDataURL("image/png"), width: pxW * scale, height: pxH * scale };
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
